export const GET_PRODUCTORIGINS = 'GET_PRODUCTORIGINS'
export const GET_PRODUCTORIGINS_EXITO = 'GET_PRODUCTORIGINS_EXITO'
export const GET_PRODUCTORIGINS_ERRROR = 'GET_PRODUCTORIGINS_ERROR'
